import { render, staticRenderFns } from "./PainelErrosComprometimentos.vue?vue&type=template&id=6e192e14"
import script from "./PainelErrosComprometimentos.vue?vue&type=script&lang=js"
export * from "./PainelErrosComprometimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports